import { makeDefaultRecord } from '@scentregroup/shared/helpers/utils';
export default function groupSegmentsByHeading({
  segmentResults,
  context,
  onResultClickHeading,
  headingsToDisplay,
  getHeadingForSegment,
  mkpCartCount
}) {
  const resultsByHeadings = makeDefaultRecord(() => []);
  const otherDetailsByHeading = makeDefaultRecord(() => ({
    queryId: '',
    indexName: ''
  }));
  Object.keys(segmentResults).forEach(segment => {
    var _segmentResults$segme;

    const hits = (_segmentResults$segme = segmentResults[segment]) === null || _segmentResults$segme === void 0 ? void 0 : _segmentResults$segme.hits;

    if (hits) {
      var _segmentResults$segme2, _segmentResults$segme3, _segmentResults$segme4, _segmentResults$segme5;

      const heading = getHeadingForSegment(segment);

      const onResultClick = hit => onResultClickHeading(heading, hit);

      const groupedHits = hits.map(hit => ({
        segment,
        hit,
        onResultClick,
        context,
        mkpCartCount
      }));
      otherDetailsByHeading[heading] = {
        queryId: (_segmentResults$segme2 = (_segmentResults$segme3 = segmentResults[segment]) === null || _segmentResults$segme3 === void 0 ? void 0 : _segmentResults$segme3.queryId) !== null && _segmentResults$segme2 !== void 0 ? _segmentResults$segme2 : '',
        indexName: (_segmentResults$segme4 = (_segmentResults$segme5 = segmentResults[segment]) === null || _segmentResults$segme5 === void 0 ? void 0 : _segmentResults$segme5.indexName) !== null && _segmentResults$segme4 !== void 0 ? _segmentResults$segme4 : ''
      };
      resultsByHeadings[heading].push(...groupedHits);
    }
  });
  return headingsToDisplay.map(heading => {
    var _otherDetailsByHeadin, _otherDetailsByHeadin2, _otherDetailsByHeadin3, _otherDetailsByHeadin4;

    return {
      indexName: (_otherDetailsByHeadin = (_otherDetailsByHeadin2 = otherDetailsByHeading[heading]) === null || _otherDetailsByHeadin2 === void 0 ? void 0 : _otherDetailsByHeadin2.indexName) !== null && _otherDetailsByHeadin !== void 0 ? _otherDetailsByHeadin : '',
      queryId: (_otherDetailsByHeadin3 = (_otherDetailsByHeadin4 = otherDetailsByHeading[heading]) === null || _otherDetailsByHeadin4 === void 0 ? void 0 : _otherDetailsByHeadin4.queryId) !== null && _otherDetailsByHeadin3 !== void 0 ? _otherDetailsByHeadin3 : '',
      heading,
      hits: resultsByHeadings[heading]
    };
  }).filter(({
    hits
  }) => hits.length > 0);
}